export default __webpack_public_path__ + "static/media/bannergopro.409a0d0a.jpg";